import { auth } from '@martyrs/src/modules/auth/views/store/auth.js'

// Куда ведёт кнопка «Назад» на страницах входа/регистрации.
//
// Обычный случай — пользователь пришёл на /auth/signin со страницы сайта, кнопка
// возвращает его туда же (router.back()).
//
// Но есть сценарии, где истории для возврата нет или она бесполезна:
//   1) прямой заход по ссылке / открытие в новой вкладке — предыдущей записи нет;
//   2) предыдущая запись — сама форма входа/регистрации (перекидывания /auth/*);
//   3) разлогин: юзер был на закрытой странице (meta.requiresAuth), его увели на
//      /auth/signin — вернуться туда нельзя, guard тут же вернёт обратно на вход.
// В этих случаях кнопка должна вести на главную.
//
// Возвращает { isHome, path }: isHome=true → показываем «На главную» и делаем
// push(path); иначе — «Назад» и router.back().
export function resolveAuthBackTarget(router) {
  const home = { isHome: true, path: '/' }

  if (typeof window === 'undefined') return home

  const back = router.options?.history?.state?.back

  if (typeof back !== 'string' || !back) return home
  if (back.startsWith('/auth/')) return home

  const resolved = router.resolve(back)

  if (!auth.state.access.status && resolved.matched.some(record => record.meta?.requiresAuth)) return home

  return { isHome: false, path: back }
}
